/*!
=========================================================
* 依頼（その他）登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardBody,  CardTitle,
  Table,  Row,  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import InputText from '../../FormParts/InputText'
import InputRadio from '../../FormParts/InputRadio'
import InputNumber from '../../FormParts/InputNumber'
import InputSelect from '../../FormParts/InputSelect';
import Request from '../../../common/Request';
import InputDatetime from '../../FormParts/InputDatetime'
import InputCheckBox from '../../FormParts/InputCheckBox';
import CustomTd from '../../ViewParts/CustomTd';
import {
  cst_want_guide_type
} from '../../../variables/codes_map';
import moment from 'moment'
import GsuiteAuth from '../../../components/Auth/GsuiteAuth';
import WithRole from '../../FormParts/ButtonWithRole';
import { GetMessage, getErrorCodes } from "../../../variables/message";
import format_url from '../../../variables/format_url';
import GoogleDrive from  "../../../common/GoogleDrive";
import { template } from "../../../variables/memoTemplate";

var domain = "";

class Regist extends React.Component {
  constructor(props){
    super(props);

    const box_status = new URL(window.location.href).searchParams.get("box_status")
    // 遷移先に遷移元を示すパラメータを渡す
    const box_status_param = `?box_status=${box_status}`
    // 遷移元に戻るための設定
    const transition_url = box_status === "0" ? "/construction/list" : "/construction/new_customer";

    this.state ={
	      detail_search: "off",
        regist_modal: false,
        error_modal: false,
        view: false,
        valid: true,
        request:{},
        customer1:{},
        customer2:{},
        data:{
          values:{
            request_date:moment().format("YYYY-MM-DDT00:00:00"),
            estimate_deadline: moment().add(4,'days').format("YYYY-MM-DDT00:00:00"),
            want_guide_type:cst_want_guide_type[0].default,
            want_guide_type_subcontract:cst_want_guide_type[0].default
          },
          errors:{},
          requiredData:{}
        },
        request_type:"",
        userData:[],
        box_status : box_status,
        box_status_param : box_status_param,
        transition_url : transition_url,
        regist_lock: false,
        regist_yes_lock: false,
    };
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.alertDateCheck = this.alertDateCheck.bind(this);

      (async () => {
      const projectUrl = domain + '/api/construction/'+this.props.match.params.project_id+"?project_only=true";
      const requestUrl = domain + '/api/request/'+this.props.match.params.request_seq;
      
      const res = (this.props.match.params.project_id !== undefined) ? 
        await new Promise((resolve,reject)=>
          Request.get(projectUrl,{
            project_ulid: this.props.match.params.project_id
          }, res => {
            const customerSystemUseFlag = res.Data.customer_user.customer.customer_system_use_flag;
            if(this.props.data_view_flag==2 && (res.Data.user_branch != GsuiteAuth.get('user_branch_id'))){
              this.props.pageChangeAlert.current.inactivate();
              this.props.history.push('/forbidden')
              return
            } else {
              this.setState({ 
                project:res.Data,
                customerSystemUseFlag : customerSystemUseFlag,
                data:{
                  ...this.state.data,
                  values:{
                    ...this.state.data.values,
                    user_branch_natural_id: res.Data.user_branch_natural_id
                  }
                }
              }, ()=>{
                this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.project)
              })
            }
            resolve(res)
          }, ()=>reject()))
        : await new Promise((resolve, reject)=>
          Request.get(requestUrl,{}, res => {
            const customerSystemUseFlag = res.Data.customer_system_use_flag;
            if(this.props.data_view_flag==2 && (res.Data.user_branch_id != GsuiteAuth.get('user_branch_id'))){
              this.props.pageChangeAlert.current.inactivate();
              this.props.history.push('/forbidden')
              return
            } else {
              const defaultWantGuideTypeSubcontract = res.Data.want_guide_type_subcontract === null ? cst_want_guide_type[0].default : res.Data.want_guide_type_subcontract;
              this.setState({ 
                data: {
                  ...this.state.data,
                  values:{
                    ...res.Data,
                    want_guide_type_subcontract : defaultWantGuideTypeSubcontract
                  }
                },
                project:res.Data,
                view:true,
                customerSystemUseFlag : customerSystemUseFlag
              }, ()=>{
                this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.project)
              })
            }
            resolve(res)
          }, ()=>reject()))
      
      const customerUserApiEndPoint = '/api/customer/user'
      const customer1 = res.Data.customer_user_natural_id && await new Promise((resolve,reject)=>{
        Request.get(customerUserApiEndPoint, {
          customer_user_natural_id:res.Data.customer_user_natural_id
        }, res=>{
          if (!res.Data[0]){
            throw {
              name:'Data Error!',
              message:'customer1 not exist'
            }
          }
          resolve(res.Data[0])
        }, ()=>reject())
      })
      const customer2 = (res.Data.subcontract_customer_user_natural_id && await new Promise((resolve,reject)=>{
        Request.get(customerUserApiEndPoint, {
          customer_user_natural_id:res.Data.subcontract_customer_user_natural_id
        }, res=>{
          if (!res.Data[0]){
            throw {
              name:'Data Error!',
              message:'customer2 not exist'
            }
          }
          resolve(res.Data[0])
        }, ()=>reject())
      }))||{}

      this.setState({
        customer1,
        customer2,
        data: {
          ...this.state.data,
          values:{
            ...this.state.data.values,
          },
        },
      })

      const requiredCheckedData = await Request.getRequiredData('/api/request/other', this.state.data)
      this.setState({
        data:requiredCheckedData
      })

      if(this.props.match.params.others_type !== undefined){
        var others_type = this.props.match.params.others_type;
        this.setState({
          request_type:others_type,
          data:{
            ...this.state.data,
            values:{
              ...this.state.data.values,
              request_type:others_type
            }
          },
        });
      }
    })()
  } 

    // 初期ロード用
    async componentDidMount(){
      /*　ここは開発者が記述　*/

      // const requiredCheckedData = await Request.getRequiredData('/api/request/other', this.state.data)
      // this.setState({
      //   data:requiredCheckedData
      // })

      // if(this.props.match.params.others_type !== undefined){
      //   var others_type = this.props.match.params.others_type;
      //   this.setState({
      //     request_type:others_type,
      //     data:{
      //       ...this.state.data,
      //       values:{
      //         ...this.state.data.values,
      //         request_type:others_type
      //       }
      //     },
      //   });
      // }

    const usersUrl = '/api/landmark/user';
    Request.get(usersUrl, {}, res => {

      const isUpdate = window.location.href.split("/").includes("update")
      const loggedInUser = res.Data.reduce((acc, user) =>{
        
        if(user.id == GsuiteAuth.get('id')){
          acc["label"] = user["name"]
          acc["value"] = user["id"]
        }
        return acc
      }, {})

      if(isUpdate){
        this.setState((prevState)=>{
          return {
            ...prevState,
            userData: res.Data,
          }
        })
      }else{
        this.setState((prevState)=>{
          return {
            ...prevState,
            userData: res.Data,
            loggedInUser:loggedInUser,
            data:{
              ...prevState.data,
              values:{
                ...prevState.data.values,
                other_survey_account: loggedInUser["value"]
              }
            }
          }
        })
      }
    })

    // 担当支店用にランドマーク支店マスタの取得
    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
            user_branch_natural_id:prop.user_branch_natural_id,
            id:prop.id
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
  }
  
  relatedCheck = () => { 
    const { customer1, customer2 } = this.state;
    const { want_guide_type, want_guide_type_subcontract } = this.state.data.values;
    const { send_destination_type } = this.state.project

    let message = getErrorCodes(this.state.data.errors)

    let checkGuideType = true;

    // 送付先が「元請けのみに送る」、「両方に送る」の場合チェックする
    if(send_destination_type === 0 || send_destination_type === 2){
      if(want_guide_type == "0" || want_guide_type == "1"){
        if(!customer1.customer_user_email){
          checkGuideType = false;
        }
      }

      if(want_guide_type == "0" || want_guide_type == "2"){
        if(!customer1.customer_branch_fax){
          checkGuideType = false;
        }
      }
    }

    // 送付先が「下請のみに送る」、「両方に送る」の場合チェックする
    if(send_destination_type === 1 || send_destination_type === 2){
      if(customer2.id && (want_guide_type_subcontract == "0" || want_guide_type_subcontract == "1")){
        if(!customer2.customer_user_email){
          checkGuideType = false;
        }
      }
      if(customer2.id && (want_guide_type_subcontract == "0" || want_guide_type_subcontract == "2")){
        if(!customer2.customer_branch_fax){
          checkGuideType = false;
        }
      }
    }

    if(checkGuideType === false){
      message.push(2416)
    }

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal,
      regist_lock: !this.state.regist_lock,
    });
  }
  toggleSubRegistModal(){
    if(this.props.match.params.construction_id != undefined){
      return null;
    }else{
      this.setState({
        sub_regist_modal: !this.state.sub_regist_modal
      });
    }
  }

  validate() {
    return Object.keys(this.state.data.errors).length===0;
  }

  alertDateCheck(newData){
    const {
      request_other_start_date,
      request_other_end_date
    } = newData.values
    const {
      request_other_start_date:prev_request_other_start_date,
    } = this.state.data.values
    if(request_other_start_date && request_other_end_date && (moment(request_other_start_date) > moment(request_other_end_date))){
      return {
        ...newData,
        errors:{
          ...newData.errors,
          ...{[(prev_request_other_start_date === request_other_start_date ? 'request_other_end_date' : 'request_other_start_date')]:[GetMessage(2462)]},
        }
      }
    }else{
      return newData
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data : this.alertDateCheck(newData)
    } , ()=>callback())
  }

  async regist() {
    if(this.validate()) {
      // console.log(this.state.request_type);
      await this.setState({
        data: {
          ...this.state.data,
          values: {
            ...this.state.data.values,
            user_branch_id : this.state.landmark_user_branch.find(data => data.value === this.state.data.values.user_branch_natural_id).id,
            user_branch_natural_id : this.state.data.values.user_branch_natural_id
          }
        },
        regist_lock: true,
        regist_yes_lock: true,
      })
      const {
        data:{
          values
        },
        customer1,
        customer2,
        project
      } = this.state
      var request_type = "";
      if(this.state.request_type){
        request_type = this.state.request_type
      }else{
        request_type = values.request_type
      }

      switch(Number(request_type)){
        case 4:
        case 5:
        case 6:
        case 7:
          // console.log(this.state.data);
          const {
            want_guide_type,
            want_guide_type_subcontract
          } = values
          const {
            customer_id,
            customer_natural_id,
            customer_branch_id,
            customer_branch_natural_id,
            id,
            customer_user_natural_id
          } = customer1
          const {
            project_natural_id,
            send_destination_type,
            site_customer_user_tel
          } = project
          const {
            customer_id : subcontract_customer_id,
            customer_natural_id : subcontract_customer_natural_id,
            customer_branch_id : subcontract_customer_branch_id,
            customer_branch_natural_id : subcontract_customer_branch_natural_id,
            id : subcontract_customer_user_id,
            customer_user_natural_id : subcontract_customer_user_natural_id,
          } = customer2

          const params = {
            ...values,
            ...(this.state.view === false)?{
              customer_id : customer_id,
              customer_natural_id : customer_natural_id,
              customer_branch_id : customer_branch_id,
              customer_branch_natural_id : customer_branch_natural_id,
              customer_user_id : id,
              customer_user_natural_id : customer_user_natural_id,
              
              subcontract_customer_id,
              subcontract_customer_natural_id,
              subcontract_customer_branch_id,
              subcontract_customer_branch_natural_id,
              subcontract_customer_user_id,
              subcontract_customer_user_natural_id,

              project_ulid : this.props.match.params.project_id,
              survey_request_date : values.request_date,
              request_other_status : 0,
              request_type,
            }:{}
          }
          var url = domain + '/api/request/other';
          if(this.state.view === false) {
            // need to get those parameters
            Request.setProgress(10)
            
            Request.setProgress(20)
            const requestCommon =  await Request.getRequestCommon({
              customer_branch_natural_id,
              customer_user_natural_id,
              project_natural_id,
              // request_natural_id,
              subcontract_customer_branch_natural_id,
              subcontract_customer_user_natural_id,
              REQUEST__request_type:values.request_type,
              REQUEST__cc_email:values.cc_email,
              REQUEST__estimate_deadline:values.estimate_deadline,
              user_branch_natural_id: values.user_branch_natural_id,
              site_customer_user_tel
            })
            const {
              CUSTOMER_USER__customer_reminder_sms_flag_code,
              CUSTOMER_USER__customer_user_tel
            } = requestCommon.object_customer
            const {
              CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
              CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
            } = requestCommon.object_customer_subcontract
            const defaultParams = {
              ...requestCommon
            }
            Request.setProgress(30)
            let a02MailRes = (
              ((send_destination_type=="2" || send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0"))
              ||((send_destination_type=="2"|| send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))
            ) 
            ? new Promise((resolve, reject)=>{
              const mailUrl = '/api/pout/A02_MAIL'
              const mailParams = {
                ...defaultParams,
                send_destination_type:send_destination_type,
                want_guide_type:want_guide_type,
                want_guide_type_subcontract:want_guide_type_subcontract,                
                format_url:GoogleDrive.getFormatUrl(format_url.A02_MAIL),
              }
              Request.post(mailUrl, mailParams, res=>{
                resolve(res)
              }, err=>{
                reject(err)
              })
            })
            :{Code:200}

            let a02FaxRes = (
              ((send_destination_type=="2" || send_destination_type=="0" ) && (want_guide_type=="2"||want_guide_type=="0"))
              ||((send_destination_type=="2"|| send_destination_type=="1") && (want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0"))
            ) 
            ? new Promise((resolve, reject)=>{
              const faxUrl = '/api/pout/A02_FAX'
              const faxParams = {
                ...defaultParams,
                send_destination_type:send_destination_type,
                want_guide_type:want_guide_type,
                want_guide_type_subcontract:want_guide_type_subcontract,                
                format_url:GoogleDrive.getFormatUrl(format_url.A02_FAX),
              }
              Request.post(faxUrl, faxParams, res=>{
                resolve(res)
              }, err=>{
                reject(err)
              })
            })
            :{Code:200}

            let a02SmsRes = (
              ( (send_destination_type=="2" || send_destination_type=="0" ) && (CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) )
              || ((send_destination_type=="2"|| send_destination_type=="1") && (CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract)
              || site_customer_user_tel)
            )
            ? new Promise((resolve, reject)=>{
              // need to fix condition
              const smsUrl = '/api/pout/A02_SMS'
              const smsParams = {
                ...defaultParams,
                send_destination_type:send_destination_type,
                want_guide_type:want_guide_type,
                want_guide_type_subcontract:want_guide_type_subcontract,                
                format_url:GoogleDrive.getFormatUrl(format_url.A02_SMS),
              }
              Request.post(smsUrl, smsParams, res=>{
                resolve(res)
              }, err=>{
                reject(err)
              })
            })
            :{Code:200}

            const a02Result = await Promise.all([a02MailRes, a02FaxRes, a02SmsRes]).then(r=>r).catch(()=>{
              Request.setProgress(0)
              return
            })
            a02MailRes = a02Result&&a02Result[0]
            a02FaxRes = a02Result&&a02Result[1]
            a02SmsRes = a02Result&&a02Result[2]
            
            Request.setProgress(60)
            if (a02MailRes&&a02MailRes.Code==200 && a02FaxRes&&a02FaxRes.Code==200 && a02SmsRes&&a02SmsRes.Code==200){
              const resultCode = await new Promise((resolve, reject)=>{
                Request.post(url, params, (res) => {
                  resolve(res.Code)
                },error =>{
                  Request.setProgress(0)
                  reject(error)
                  this.props.alertModal.current.showErrorModal({messageNo:2402})
                })
              })
              if (resultCode!=200){
                Request.setProgress(0)
              }

              const sendMailUrl = '/api/send/MAIL'
              a02MailRes.Data&&a02MailRes.Data.forEach((mailData)=>{
                Request.post(sendMailUrl, mailData, res=>{
                
                }, err=>{
                  
                },undefined, true, false)
              })
              
              const sendFaxUrl = '/api/send/FAX'
              a02FaxRes.Data&&a02FaxRes.Data.forEach((faxData)=>{
                Request.post(sendFaxUrl, faxData, res=>{
                
                }, err=>{
                  
                },undefined, true, false)
              })
              // 2520 対応
              const resultSms = await new Promise((resolve, reject) => {
                if (a02SmsRes.Data == undefined) {
                  resolve({Code: 200})
                }
                const sendSmsUrl = '/api/send/SMS'
                a02SmsRes.Data && a02SmsRes.Data.forEach((smsData) => {
                  if (smsData.site_flag == true) {
                    if (smsData.site_error == true) {
                      const registerType = Number(this.state.project.register_type);
                      // console.log(smsData)
                      if (registerType === 0) {
                        resolve({Code: 200})
                      }else{
                        resolve({Code: 2631})
                      }
                    }else{
                      Request.post(sendSmsUrl, smsData, res => {
                        if (res.Data && res.Data.sms_status == 'accepted'){
                          resolve({Code: 200})
                        }else{
                          resolve({Code: 2631, data: res.Data})
                        }
                      }, err => {
                        resolve({Code: 2631, data: err})
                      }, undefined, true, false)
                    }
                  }else{
                    Request.post(sendSmsUrl, smsData, res => {
                    }, err => {
                    }, undefined, true, false)
                  }
                })
              })  

              Request.setProgress(80)
              if (resultCode == 200){
                
                Request.setProgress(0)
                this.props.pageChangeAlert.current.inactivate()
                if(((send_destination_type=="2" || send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0")) 
                ||((send_destination_type=="2"|| send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
                  window.open(`https://mail.google.com/mail/u/0/#drafts`);
                }
                if (resultSms.Code == 200) {
                  this.props.alertModal.current.confirmCheck({
                    title: "処理完了",
                    messageNo: [2417,2471],
                    closeBtn: false
                  }, ()=>this.props.history.push(this.state.transition_url), false)
                } else {
                  console.log(resultSms);
                  let title = "エラー"
                  let message = GetMessage(2631)
                  if (resultSms.data && resultSms.data.sms != "") {
                    message = message + "<br />\n" + resultSms.data.sms
                  }
                  this.props.alertModal.current.confirmCheck({
                    title: title,
                    message: message ,
                    closeBtn: false
                  }, () => this.props.history.push(this.state.transition_url), false)
                }
              }

            }else{
              Request.setProgress(0)
            }
          } else {
            url = url + "/" + this.props.match.params.request_seq;
            Request.put(url, params, async res => {
              Request.setProgress(0)
              if (res.Code == 200){
                this.props.pageChangeAlert.current.inactivate()
                this.props.history.push(`/construction/other/detail/${this.props.match.params.request_seq}${this.state.box_status_param}`)
              }
            },error =>{
              Request.setProgress(0)
              this.props.alertModal.current.showErrorModal({messageNo:2403})
              console.log(error);
            });
          }      
        break;
      }
    }else{
      this.props.alertModal.current.showErrorModal({messageNo:2401})
    }
  }

  presave() {
    // TODO 一時保存API呼び出し
    this.togglePresaveModal();
  }
  button_name(){
    if(this.state.view === false){
      return "登録";
    }else{
      return "更新";
    }
  }
  title_name(){
    if(this.state.view === false) {
      return "依頼（その他）登録";
    }else{
      return "依頼（その他）更新";
    }
  }

  validateCallBack = (newData, callback=()=>{})=>{
    const data = this.state.data;
    this.setState({
      data:{
        ...data,
        ...newData
      }
    }, ()=>callback())
  }

  copyToContectMemo(){
    const seletedMemo = this.state.data.values.temp_contact_memo || "";
    this.setState({
      data : {
        ...this.state.data,
        values : {
          ...this.state.data.values,
          contact_memo : seletedMemo
        }
      }
    })
  }

  render() {
    const {
      customer1,
      customer2
    } = this.state
    console.log('state', this.state)
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.project)
    
    const otherSurveyAccountOptions = this.state.userData.reduce((acc, user) =>{
      if(user.user_branch_id == GsuiteAuth.get('user_branch_id')){
        acc.push({
          label: user["name"],
          value:user["id"]
        })
      }
      return acc
    }, [])

    return (
      <>
    <div className="content" {...{inert:this.state.regist_lock?"":undefined}}>
      <Row>
      <Col md="12">
      <Card>
      <CardHeader>
        <CardTitle tag="h3">{this.title_name()}</CardTitle>
      </CardHeader>
        <Col md="11" className="detail">
          <CardBody>
          <Table>
              <tbody>
                <tr>      
                  <CustomTd 
                    label="会社名" 
                    name="CUSTOMER__customer_name" 
                    copy={false}
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="支店名" 
                    name="CUSTOMER_BRANCH__customer_branch_name" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="電話番号" 
                    name="CUSTOMER_BRANCH__customer_branch_tel" 
                    copy={false} 
                    data={customer1}
                  />                      
                </tr>
                <tr>
                  <CustomTd 
                    label="FAX番号" 
                    name="CUSTOMER_BRANCH__customer_branch_fax" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="顧客担当者" 
                    name="CUSTOMER_USER__customer_user_name" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="携帯電話番号" 
                    name="CUSTOMER_USER__customer_user_tel" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="メールアドレス" 
                    name="CUSTOMER_USER__customer_user_email" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="会社名（下請）" 
                    name="CUSTOMER__customer_name" 
                    copy={false}
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="支店名（下請）" 
                    name="CUSTOMER_BRANCH__customer_branch_name" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="電話番号（下請）" 
                    name="CUSTOMER_BRANCH__customer_branch_tel" 
                    copy={false} 
                    data={customer2}
                  />                      
                </tr>
                <tr>
                  <CustomTd 
                    label="FAX番号（下請）" 
                    name="CUSTOMER_BRANCH__customer_branch_fax" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="顧客担当者（下請）" 
                    name="CUSTOMER_USER__customer_user_name" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="携帯電話番号（下請）" 
                    name="CUSTOMER_USER__customer_user_tel" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="メールアドレス（下請）" 
                    name="CUSTOMER_USER__customer_user_email" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd label='工事番号'
                    name='PROJECT__construction_number'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='現場名'
                    name='PROJECT__site_name'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='現場名（カナ）'
                    name='PROJECT__site_name_kana'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='工事開始日'
                    name='PROJECT__project_start_date'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='工事終了日'
                    name='PROJECT__project_finish_date'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='都道府県'
                    name='PROJECT__site_prefecture'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='市区町村'
                    name='PROJECT__site_city'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd label='番地（町名以降）'
                    name='PROJECT__site_address'
                    copy={false}
                    data={this.state.project} />
                </tr>
                <tr>
                  <CustomTd 
                    label="送付先"
                    name="PROJECT__send_destination_type" 
                    copy={false} 
                    data={this.state.project}
                  />
                </tr>
                <tr>
                  <CustomTd label='担当支店'
                    name='REQUEST__user_branch_natural_id'
                    colSpan="3"
                    value={
                      <InputSelect label="担当支店"
                        labelOn={false}
                        validateCallback={this.validateCallback}
                        rootData={this.state.data}
                        validateType="regist"
                        options={this.state.landmark_user_branch}
                      />
                    }
                  />
                </tr>
                <tr>
                  <CustomTd label='担当者'
                      name='REQUEST__other_survey_account'
                      copy={false}
                      rootData={this.state.data}
                      value={
                      <InputSelect 
                        label="ユーザ"
                        name="USER__id"
                        options={otherSurveyAccountOptions}
                        rootData={this.state.data.values}
                        validateCallback={this.validateCallBack} 
                        isSearchable={true}
                      />
                    }
                  />
                </tr>
              </tbody>
            </Table>
          </CardBody>
          <CardBody>
            <Table>
              <tbody>
                <tr>
                    {/* <th rowSpan='3' className='text-left'>依頼情報</th> */}
                    <CustomTd label='依頼種別'
                      name='REQUEST__request_type'
                      copy={false}
                      data={this.state.data.values?this.state.data.values:""} />                      
                </tr>
                <tr>
                  <CustomTd label='受付日'
                      name='REQUEST__request_date'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputDatetime
                          disabled={true}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  <CustomTd label='着手期限日'
                      name='REQUEST__request_other_deadline'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputDatetime
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  {/* <th rowSpan='2' className='text-left'>契約期間</th> */}
                  <CustomTd label='契約開始日'
                      name='REQUEST__request_other_start_date'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputDatetime
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  <CustomTd label='契約終了日'
                      name='REQUEST__request_other_end_date'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputDatetime
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  {/* <th className='text-left'>利用数</th> */}
                  <CustomTd label='個数'
                      name='REQUEST__request_other_qty'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputNumber
                          unit="台"
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  {/* <th rowSpan="2" className='text-left'>希望詳細</th> */}
                  <CustomTd label='顧客からの要望'
                      name='REQUEST__customer_other_request'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputText multiline={true}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  <CustomTd label='CCメールアドレス'
                      name='REQUEST__cc_email'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputText
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                          placeholder="支店マスタに登録されてないCCメールアドレスを入力してください。"
                        />
                      }
                  />
                </tr>
                <tr>
                  <CustomTd label='案内方法'
                      name='REQUEST__want_guide_type'
                      copy={false}
                      rootData={this.state.data}
                      value={
                        <InputRadio
                          options={cst_want_guide_type}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                  />
                </tr>
                <tr>
                  <CustomTd label='案内方法（下請）'
                    name='REQUEST__want_guide_type_subcontract'
                    copy={false}
                    rootData={this.state.data}
                    value={
                      <InputRadio
                        disabled={!customer2.customer_id}
                        options={cst_want_guide_type}
                        validateCallback={this.validateCallback} 
                        validateType='regist'
                      />
                    }
                  />
                </tr>
                {/* 顧客システム利用の場合のみ */}
                {this.state.customerSystemUseFlag === 1 && (<>
                    <tr style={{display: 'none'}}>
                      <td className="subTitle">顧客連絡用コメント候補</td>
                      <td className="line-break">
                        <Row>
                          <Col>
                            <InputSelect 
                              label="顧客連絡用コメント候補"
                              name="REQUEST__temp_contact_memo"
                              options={template}
                              rootData={this.state.data}
                              validateCallback={this.validateCallback} 
                              isSearchable={true}
                            />
                            <Button style={{marginTop : 10}}onClick={()=>this.copyToContectMemo()}>選択した候補を下へコピー</Button>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr style={{display: 'none'}}>
                      <td className="subTitle">顧客連絡用コメント</td>
                      <td className="line-break">
                        <Row>
                          <Col>
                            <InputText 
                              multiline={true}
                              name='REQUEST__contact_memo'
                              rootData={this.state.data}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          </Col>
                        </Row>
                      </td>
                    </tr>
                  </>)}
              </tbody>
            </Table>
          </CardBody>
        </Col>
        <Row md='12' className="detail">
          <Col md='6' className="text-center">
            <Button color="secondary" disabled={this.state.regist_lock} onClick={() => { 
              if(this.state.view === false){
                this.props.history.push(this.state.transition_url)
              } else {
                this.props.history.push(`/construction/other/detail/${this.props.match.params.request_seq}${this.state.box_status_param}`) 
              }
            }}>キャンセル</Button>
          </Col>
          <Col md='6' className="text-center">
            <ButtonWithRole
              button_id={this.state.view?"BTN_AX_03_01320":"BTN_AX_01_01260"}
              color="info"
              disabled={this.state.regist_lock}
              onSubmit={e => {e.preventDefault();}}
              onClick={() => {
                if(this.relatedCheck()){
                  this.toggleRegistModal()
                 }
              }}
            >
              {this.button_name()}
            </ButtonWithRole>
          </Col>
        </Row>
      </Card>
      </Col>
      </Row>
    </div>
      <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
       <div className="modal-header">
         <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
           <i className="tim-icons icon-simple-remove"></i>
         </button>
         <h5 className="modal-title">{this.button_name()}</h5>
       </div>
       <ModalBody>
         <p>{this.button_name()}しますか？</p>
       </ModalBody>
       <ModalFooter>
         <Button color="secondary" onClick={this.toggleRegistModal}>
           いいえ
         </Button>
         <ButtonWithRole 
          button_id={this.state.view?"BTN_AX_03_01340":"BTN_AX_01_01280"}
          color="info"
          disabled={this.state.regist_yes_lock}
          onClick={() => {
            this.toggleRegistModal()
            this.regist()
            this.toggleSubRegistModal()
          }}>
           はい
         </ButtonWithRole>
       </ModalFooter>
     </Modal>    
     </>
    );

  }
}

export default Regist;
